import React from "react";
import { useNode, useEditor, UserComponent } from "@craftjs/core";
import styled from "@emotion/styled";

import { YoutubeSettings } from "./YoutubeSettings";

const YoutubeDiv = styled.div<any>`
  display: flex;
  flex-direction: column;
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;
  margin-top: 20px;
  width: 100%;
  align-self: center;

  > div {
    left: 0;
    width: 100%;
    height: 0;
    position: relative;
    padding-bottom: 56.25%;
  }
`;

export interface IYoutubeProps {
  videoId: string;
  width: string;
  height: string;
}

export const Youtube: UserComponent<Partial<IYoutubeProps>> = ({
  videoId,
  width = "100%",
  height = "auto",
}) => {
  const {
    connectors: { connect },
    setProp,
  } = useNode();

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  return (
    <YoutubeDiv ref={connect} enabled={enabled} width={width} height={height}>
      <div>
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          onClick={(e) => {
            e.preventDefault();
          }}
          style={{
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            position: "absolute",
            border: 0,
          }}
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
        />
      </div>
      {/* <YouTube
        videoId={videoId}
        opts={{
          width: '100%',
          height: '100%',
        }}
      /> */}
    </YoutubeDiv>
  );
};

Youtube.craft = {
  displayName: "Youtube",
  props: {},
  related: {
    toolbar: YoutubeSettings,
  },
};
